<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useHead } from '@unhead/vue';
import { TooltipProvider } from 'reka-ui';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ToastViewport from '@/components/ui/ToastViewport.vue';
import { isLocale } from '@/i18n';
import { usePrefsStore } from '@/stores/prefs';
import { useSessionStore } from '@/stores/session';

const route = useRoute();
const prefs = usePrefsStore();
const session = useSessionStore();
const { locale, t } = useI18n();

useHead({
  htmlAttrs: { lang: () => locale.value },
  titleTemplate: (title) => title ?? 'StoryPoints',
  meta: [{ name: 'application-name', content: () => t('app.name') }],
});

onMounted(() => {
  prefs.hydrate(route.meta.locale ?? null);
  if (!route.meta.locale && isLocale(prefs.locale)) locale.value = prefs.locale;
  void session.load();
});

watch(
  () => route.meta.locale,
  (value) => {
    if (value && prefs.hydrated && prefs.locale !== value) prefs.setLocale(value);
  },
);
</script>

<template>
  <a href="#main" class="sr-only-focusable fixed start-4 top-4 z-[70] rounded-md bg-primary px-4 py-2 font-medium text-on-primary">
    {{ t('common.skipToContent') }}
  </a>
  <TooltipProvider :delay-duration="400">
    <RouterView />
  </TooltipProvider>
  <ToastViewport />
</template>
